module.exports = __webpack_public_path__ + "static/media/Download1.d5163487.jpg";